import React from 'react'
import PropTypes from 'prop-types'
import { annnotation_type } from '../components/InlineToolbarButton'

const AnnotationTextNode = ({
  store,
  getEditorState,
  entityKey,
  children,
  clickSubject,
  decoratedText,
}) => {
  const entity = getEditorState().getCurrentContent().getEntity(entityKey)
  const entityData = entity ? entity.get('data') : undefined

  let categoryId, itemId, childId
  if (entityData) {
    categoryId = entityData.categoryId
    itemId = entityData.itemId
    childId = entityData.childId
  }

  const annotationClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (clickSubject) {
      store.updateInlineToolbar(true)
      setTimeout(() => {
        clickSubject.next({
          type: annnotation_type,
          decoratedText,
          entityData: entityData || {},
        })
      }, 0)
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <span
      className="annotations-text"
      data-annotation-category={categoryId}
      data-annotation-item={itemId}
      data-annotation-child={childId ?? ''}
      onClick={annotationClick}
    >
      {children}
    </span>
  )
}

const propTypes = {
  getEditorState: PropTypes.func.isRequired,
  entityKey: PropTypes.string,
  clickSubject: PropTypes.any,
  store: PropTypes.object.isRequired,
}

AnnotationTextNode.propTypes = propTypes
export default AnnotationTextNode
